module.exports = __webpack_public_path__ + "static/event_main-d26e4a0dc83330d9c91b170199749905.png";